document.addEventListener("DOMContentLoaded", function () {
  const bundleContainers = document.querySelectorAll('[id^="bundle-container-"]');
  const scalapayWidget = document.querySelector('scalapay-widget');

  bundleContainers.forEach(function (container) {
    const quantityWrappers = container.querySelectorAll(".bundle-form__quantity");
    const priceContainer = container.querySelector(".bundle-item__price");

    function updateBundleTotal() {
      let currentTotalCents = 0;
      const itemRows = container.querySelectorAll('.bundle-item__row');

      itemRows.forEach(row => {
        const priceContainer = row.querySelector(".bundle-item__price");
        const input = row.querySelector(".bundle-quantity__input");
        
        if (priceContainer && input) {
          const priceCents = Number.parseInt(priceContainer.getAttribute('data-price')) || 0;
          const quantity = Number.parseInt(input.value) || 0;
          currentTotalCents += (priceCents * quantity);
        }
      });

      if (scalapayWidget) {
        const formattedTotal = (currentTotalCents / 100).toFixed(2);
        scalapayWidget.setAttribute('amount', formattedTotal);
      }
    }

    updateBundleTotal();

    quantityWrappers.forEach(function (wrapper) {
      const input = wrapper.querySelector(".bundle-quantity__input");
      const btnMinus = wrapper.querySelector('button[name="minus"]');
      const btnPlus = wrapper.querySelector('button[name="plus"]');

      if (!input || !btnMinus || !btnPlus) return;

      input.addEventListener("change", function () {
        updateBundleTotal();
      });

      btnMinus.addEventListener("click", function (e) {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        const step = parseInt(input.getAttribute("step")) || 1;
        const min = parseInt(input.getAttribute("min")) || 0;
        const newValue = currentValue - step;

        if (newValue >= min) {
          input.value = newValue;
        } else {
          input.value = min;
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      btnPlus.addEventListener("click", function (e) {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        const step = parseInt(input.getAttribute("step")) || 1;
        const max = input.hasAttribute("max") ? parseInt(input.getAttribute("max")) : Infinity;
        const newValue = currentValue + step;

        if (newValue <= max) {
          input.value = newValue;
        } else if (max !== Infinity) {
          input.value = max;
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    const addBtn = container.querySelector('[id^="add-bundle-btn-"]');
    const errorMsg = container.querySelector('[id^="bundle-error-"]');

    if (addBtn) {
      addBtn.addEventListener("click", function (e) {
        e.preventDefault();
        errorMsg.style.display = "none";
        
        let itemsToAdd = [];
        const qtyInputs = container.querySelectorAll(".bundle-quantity__input");

        qtyInputs.forEach((input) => {
          const qty = parseInt(input.value);
          const variantId = input.getAttribute("data-variant-id");

          if (qty > 0 && variantId) {
            itemsToAdd.push({
              id: parseInt(variantId),
              quantity: qty,
            });
          }
        });

        if (itemsToAdd.length === 0) {
          console.log(container.getAttribute("data-error-message"))
          errorMsg.textContent = container.getAttribute("data-error-message");
          errorMsg.style.display = "block";
          return;
        }

        addBtn.setAttribute("disabled", "disabled");
        const spinner = addBtn.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: itemsToAdd }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status && data.status >= 400) {
              throw new Error(data.description || "Errore API");
            }
            window.location.href = window.Shopify.routes.root + "cart";
          })
          .catch((error) => {
            errorMsg.textContent = error.message;
            errorMsg.style.display = "block";
            addBtn.removeAttribute("disabled");
            if (spinner) spinner.classList.add("hidden");
          });
      });
    }
  });
});